import { render } from "./ClientCMSAgentStatus.vue?vue&type=template&id=23856c24&scoped=true"
import script from "./ClientCMSAgentStatus.vue?vue&type=script&lang=js"
export * from "./ClientCMSAgentStatus.vue?vue&type=script&lang=js"

import "./ClientCMSAgentStatus.vue?vue&type=style&index=0&id=23856c24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23856c24"]])

export default __exports__